// extracted by mini-css-extract-plugin
export default {"backgroundImage":"rrA2sw","moveBackgroundLower":"xZw7qz"};